export default __webpack_public_path__ + "static/media/my_transactions_icon_active.10d9b1e8.svg";